module.exports = __webpack_public_path__ + "components/flag/static/square/ls-6672f8037bc79eaa2e077c47517bf0a8.svg";